var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavnenabavke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18125_12142",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18125_12142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 18V6H21V9.2885H20L15.7885 13.5H6.5V14.5H14.7885L11.2885 18H3ZM6.5 10.5H11.5V9.5H6.5V10.5ZM13.3077 19.923V19.1345L19.4193 13.023L20.2078 13.8115L14.0962 19.923H13.3077ZM20.7693 13.2115L19.9807 12.423L20.7633 11.6413C20.8358 11.5689 20.9154 11.5328 21.0023 11.5328C21.0893 11.5328 21.168 11.568 21.2385 11.6385L21.5538 11.9538C21.6243 12.0259 21.6595 12.1052 21.6595 12.1915C21.6595 12.278 21.6233 12.3574 21.551 12.4297L20.7693 13.2115Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavnenabavke);
export default __webpack_public_path__ + "static/media/javnenabavke.7a7a99dcd6aba2288734c43a54928bb0.svg";
export { ForwardRef as ReactComponent };